// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5L-SG","mainImage":"Header_mainImage__k-fli"};